const DotNav = require('../components/DotNav').DotNav;
const $ = require('jquery');

new DotNav();

// Hide the sticky sub-nav while the hero section is in view — moved out of the
// global app.js since #hero-section/.integrations__fixed-nav only exist here.
function scrollToBlock(cur_block, callback, additionalOffset) {
	if ($(cur_block).length == 0) return;

	var isIn = checkIsIN();
	if (callback) callback(isIn);

	function checkIsIN() {
		var hT = cur_block.offset().top,
			hH = cur_block.outerHeight(),
			wH = $(window).height(),
			wS = additionalOffset ? $(window).scrollTop() + additionalOffset : $(window).scrollTop();
		return wS > (hT + hH - wH) && (hT > wS) && (wS + wH > hT + hH);
	}

	document.addEventListener('scroll', function () {
		if (checkIsIN()) {
			cur_block.addClass('in');
			if (!isIn) { if (callback) callback(true); isIn = true; }
		} else {
			cur_block.removeClass('in');
			if (isIn) { if (callback) callback(false); isIn = false; }
		}
	}, { passive: true });
}

var $integrationsNav = $('.integrations__fixed-nav');
scrollToBlock($('#hero-section'), function (isIn) {
	if (isIn) $integrationsNav.addClass('is-invisible');
	else $integrationsNav.removeClass('is-invisible');
});
